export const translations = {
  en: {
    nav: {
      values: 'Why Choose Us',
      catalog: 'Catalog',
      about: 'About Us',
      quality: 'Quality',
      logistics: 'Logistics',
      certifications: 'Certifications',
      contact_nav: 'Contact Us',
      whatsapp: 'WhatsApp',
      contact: 'Contact Us'
    },
    hero: {
      badge: 'Trusted Seafood Importer',
      title: 'Your Trusted Partner for Premium Wild-Caught Seafood from Mauritania',
      titleHighlight: '',
      titleEnd: '',
      subtitle: 'SEAFOOD PRODUCTS — PREMIUM WILD-CAUGHT SEAFOOD FROM MAURITANIA',
      btnPrimary: 'Explore Our Products',
      btnSecondary: 'Request Catalog',
      stat1: 'Container Imports',
      stat2: 'Target Markets',
      stat3: 'Cold Chain Monitoring',
      freshCatch: 'Wild-Caught',
      delivery: 'Atlantic Ocean Sourced',
      location: 'Canada-Based Importer',
      locationDesc: 'Supplying professional buyers across Canada and international markets',
      scroll: 'Scroll'
    },
    values: {
      badge: 'Why Choose Us?',
      title: 'WHY CHOOSE US?',
      subtitle: 'Our operations are designed to meet the needs of professional seafood buyers through reliable sourcing, structured import processes, and consistent supply.',
      reliability: {
        title: 'Premium wild seafood',
        description: 'Sourcing exclusively wild-caught seafood from the pristine waters of the Mauritanian Atlantic Ocean.',
        features: [
          'Premium wild seafood',
          'Professional service',
          'Reliable partners',
          'Fast response'
        ]
      },
      accessibility: {
        title: 'Professional service',
        description: 'Dedicated supply solutions for professional buyers, distributors, and food service companies.',
        features: [
          'Importers, distributors, wholesalers',
          'Food service companies',
          'Long-term partnerships',
          'Structured supply agreements'
        ]
      },
      sustainability: {
        title: 'Consistent quality',
        description: 'Controlled logistics and structured import operations ensuring consistent product availability across international markets.',
        features: [
          'Reliable partners',
          'Fast response',
          'Consistent quality',
          'Controlled cold chain'
        ]
      }
    },
    catalog: {
      badge: 'Our Products',
      title: 'OUR PRODUCTS',
      subtitle: 'Fishing Area: FAO 34 – Eastern Central Atlantic | Presentation: Whole Round (Ungutted) | Packing: 10 kg or 20 kg carton upon request | Storage: -18°C',
      // ungutted: 'All products are supplied whole and ungutted.',
      viewDetails: 'View Details',
      categories: {
        title: 'OUR CATEGORIES',
        cat1Title: 'Crustaceans',
        cat1Sub: 'Lobster / Shrimp',
        cat2Title: 'Demersal Fish',
        cat2Sub: 'Sea Bream / Grouper / Sole / Goatfish / Dentex',
        cat3Title: 'Pelagic Fish',
        cat3Sub: 'Mackerel / Sardine / Horse Mackerel',
        cat4Title: 'Cephalopods',
        cat4Sub: 'Octopus / Squid / Cuttlefish',
      },
      fish: {
        octopus: 'Common octopus / Poulpe',
        squid: 'European squid / Calmar',
        seaBream: 'Sea Bream',
        shrimp: 'Deep water rose shrimp / Crevette rose',
        sardines: 'Sardines',
        sole: 'Sole',
        cuttlefish: 'Common cuttlefish / Seiche commune',
        lobster: 'Pink spiny lobster / Langouste rose',
        cynoglossus: 'Senegalese tonguesole / Sole-langue sénégalaise',
        soleaSenegalensis: 'Senegalese sole / Sole de Roche',
        soleaSolea: 'Bastard sole / Sole Perdrix juive',
        synaptura: 'Guinean sole / Sole Tigrée',
        psettodes: 'Dogsole / Turbot',
        epinephelusAeneus: 'White grouper / Mérou blanc',
        epinephelusGuaza: 'Dusky grouper / Mérou brun',
        pseudotolithus: 'Senegalese croaker / Courbine du Sénégal',
        sparusAurata: 'Gilthead seabream / Dorade royale',
        pagrusAuriga: 'Redbanded seabream / Dorade',
        pagrusCaruleus: 'Bluespotted seabream / Dorade',
        pseudupeneus: 'West African goatfish / Rouget',
        zeusFaber: 'John Dory / Saint-Pierre',
        argyrosomus: 'Meagre / Maigre',
        pomatomus: 'Bluefish / Tassergal',
        branchiostegus: 'Branchiostegus / À confirmer',
        dicentrarchus: 'Spotted seabass / Bar tacheté',
        plectorhinchus: 'Grunt / Grondeur',
        anisotremus: 'Grunt / Grondeur',
        trachurus: 'Mediterranean horse mackerel / Chinchard',
        trachurusTrachurus: 'Atlantic horse mackerel / Chinchard',
        dentexMacrophthalmus: 'Large-eye dentex / Denté',
        dentexAngolensis: 'Angolan dentex / Denté',
        campogramma: 'Vadigo / À confirmer',
        brotula: 'Bearded brotula / Brotule',
        galeichthys: 'Catfish / Poisson-chat',
        scomber: 'Atlantic mackerel / Maquereau',
        stromateus: 'Butterfish / Fiatole',
        mugilCephalus: 'Flathead mullet / Mulet',
        mugilCurema: 'White mullet / Mulet blanc',
        pagellus: 'Red pandora / Pageot',
        brachydeuterus: 'Bigeye grunt / Grondeur',
        chloroscombrus: 'Atlantic bumper / Plat-plat',
        drepane: 'African sicklefish / Forgeron',
        raja: 'Brown ray / Raie',
        rhinobatos: 'Guitarfish / Poisson guitare',
        pomadasys: 'Grunt / Grondeur',
        galeoides: 'Lesser African threadfin / Capitaine',
        sardinellaAurita: 'Round sardinella / Sardinelle ronde',
        sardinellaMaderensis: 'Madeiran sardinella / Sardinelle plate',
        sardinaPilchardus: 'European pilchard / Sardine commune',
        diplodus: 'White seabream / Sar commun',
        pomadasysJubelini: 'Sompat grunt / Grondeur sompat',
        sardaSarda: 'Atlantic bonito / Bonite à dos rayé',
        katsuwonus: 'Skipjack tuna / Bonite à ventre rayé',
        thunnusThynnus: 'Bluefin tuna / Thon rouge',
        oreochromisNiloticus: 'Nile tilapia / Tilapia du Nil',
      },
      cat: {
        whiteFish: 'White Fish',
        crustaceans: 'Crustaceans',
        smallPelagics: 'Small Pelagics',
        flatfish: 'Flatfish',
        cephalopods: 'Cephalopods',
        cephalopodesCrustaces: 'Cephalopods / Crustaceans',
        soles: 'Soles',
        merous: 'Groupers',
        courbinesDorades: 'Croakers / Seabreams',
        demersauxDivers: 'Demersal Species',
        'pelagiquesChínchards': 'Pelagics / Horse Mackerel',
        dentesSparides: 'Dentex / Sparidae',
        casAVerifier: 'To Be Confirmed',
        autresEspeces: 'Other Species',
        raiesSelaciens: 'Rays / Elasmobranchs',
        demersauxSuite: 'Demersal Species (cont.)',
        petitsPelagiques: 'Small Pelagics',
        thonsBonites: 'Tunas / Bonitos',
        eauDouce: 'Freshwater',
      },
      desc: {
        octopus: 'Wild-caught Atlantic octopus from FAO 34 — Eastern Central Atlantic',
        squid: 'Wild-caught European squid from FAO 34 — Eastern Central Atlantic',
        seaBream: 'Premium sea bream from pristine coastal waters',
        shrimp: 'Wild-caught deep-water rose shrimp from FAO 34 — Eastern Central Atlantic',
        sardines: 'Nutrient-rich sardines from the Atlantic coast',
        sole: 'Delicate sole fish, perfect for fine dining',
        cuttlefish: 'Wild-caught common cuttlefish from FAO 34 — Eastern Central Atlantic',
        lobster: 'Wild-caught pink spiny lobster from FAO 34 — Eastern Central Atlantic',
        cynoglossus: 'Wild-caught Senegalese tonguesole from FAO 34 — Eastern Central Atlantic',
        soleaSenegalensis: 'Wild-caught Senegalese sole from FAO 34 — Eastern Central Atlantic',
        soleaSolea: 'Wild-caught bastard sole from FAO 34 — Eastern Central Atlantic',
        synaptura: 'Wild-caught Guinean sole from FAO 34 — Eastern Central Atlantic',
        psettodes: 'Wild-caught dogsole from FAO 34 — Eastern Central Atlantic',
        epinephelusAeneus: 'Wild-caught white grouper from FAO 34 — Eastern Central Atlantic',
        epinephelusGuaza: 'Wild-caught dusky grouper from FAO 34 — Eastern Central Atlantic',
        pseudotolithus: 'Wild-caught Senegalese croaker from FAO 34 — Eastern Central Atlantic',
        sparusAurata: 'Wild-caught gilthead seabream from FAO 34 — Eastern Central Atlantic',
        pagrusAuriga: 'Wild-caught redbanded seabream from FAO 34 — Eastern Central Atlantic',
        pagrusCaruleus: 'Wild-caught bluespotted seabream from FAO 34 — Eastern Central Atlantic',
        pseudupeneus: 'Wild-caught West African goatfish from FAO 34 — Eastern Central Atlantic',
        zeusFaber: 'Wild-caught John Dory from FAO 34 — Eastern Central Atlantic',
        argyrosomus: 'Wild-caught meagre from FAO 34 — Eastern Central Atlantic',
        pomatomus: 'Wild-caught bluefish from FAO 34 — Eastern Central Atlantic',
        branchiostegus: 'Wild-caught branchiostegus from FAO 34 — Eastern Central Atlantic',
        dicentrarchus: 'Wild-caught spotted seabass from FAO 34 — Eastern Central Atlantic',
        plectorhinchus: 'Wild-caught grunt from FAO 34 — Eastern Central Atlantic',
        anisotremus: 'Wild-caught grunt from FAO 34 — Eastern Central Atlantic',
        trachurus: 'Wild-caught Mediterranean horse mackerel from FAO 34 — Eastern Central Atlantic',
        trachurusTrachurus: 'Wild-caught Atlantic horse mackerel from FAO 34 — Eastern Central Atlantic',
        dentexMacrophthalmus: 'Wild-caught large-eye dentex from FAO 34 — Eastern Central Atlantic',
        dentexAngolensis: 'Wild-caught Angolan dentex from FAO 34 — Eastern Central Atlantic',
        campogramma: 'Wild-caught vadigo from FAO 34 — Eastern Central Atlantic',
        brotula: 'Wild-caught bearded brotula from FAO 34 — Eastern Central Atlantic',
        galeichthys: 'Wild-caught catfish from FAO 34 — Eastern Central Atlantic',
        scomber: 'Wild-caught Atlantic mackerel from FAO 34 — Eastern Central Atlantic',
        stromateus: 'Wild-caught butterfish from FAO 34 — Eastern Central Atlantic',
        mugilCephalus: 'Wild-caught flathead mullet from FAO 34 — Eastern Central Atlantic',
        mugilCurema: 'Wild-caught white mullet from FAO 34 — Eastern Central Atlantic',
        pagellus: 'Wild-caught red pandora from FAO 34 — Eastern Central Atlantic',
        brachydeuterus: 'Wild-caught bigeye grunt from FAO 34 — Eastern Central Atlantic',
        chloroscombrus: 'Wild-caught Atlantic bumper from FAO 34 — Eastern Central Atlantic',
        drepane: 'Wild-caught African sicklefish from FAO 34 — Eastern Central Atlantic',
        raja: 'Wild-caught brown ray from FAO 34 — Eastern Central Atlantic',
        rhinobatos: 'Wild-caught guitarfish from FAO 34 — Eastern Central Atlantic',
        pomadasys: 'Wild-caught grunt from FAO 34 — Eastern Central Atlantic',
        galeoides: 'Wild-caught lesser African threadfin from FAO 34 — Eastern Central Atlantic',
        sardinellaAurita: 'Wild-caught round sardinella from FAO 34 — Eastern Central Atlantic',
        sardinellaMaderensis: 'Wild-caught Madeiran sardinella from FAO 34 — Eastern Central Atlantic',
        sardinaPilchardus: 'Wild-caught European pilchard from FAO 34 — Eastern Central Atlantic',
        diplodus: 'Wild-caught white seabream from FAO 34 — Eastern Central Atlantic',
        pomadasysJubelini: 'Wild-caught sompat grunt from FAO 34 — Eastern Central Atlantic',
        sardaSarda: 'Wild-caught Atlantic bonito from FAO 34 — Eastern Central Atlantic',
        katsuwonus: 'Wild-caught skipjack tuna from FAO 34 — Eastern Central Atlantic',
        thunnusThynnus: 'Wild-caught bluefin tuna from FAO 34 — Eastern Central Atlantic',
        oreochromisNiloticus: 'Wild-caught Nile tilapia from FAO 34 — Eastern Central Atlantic',
      }
    },
    about: {
      badge: 'About AUTOFIT CANADA',
      title: 'ABOUT US',
      titleHighlight: '',
      description1: 'AUTOFIT CANADA LTD is a Canadian company specialized in the import and distribution of premium wild seafood products from Mauritania. Through our network of approved partners and processing plants, we supply products that meet the requirements of international markets including Canada, Europe, Africa, and Asia.',
      missionTitle: 'WE FOCUS ON',
      mission: 'Premium quality · Full traceability · Controlled cold chain · Food safety compliance · Reliable logistics · Sustainable partnerships',
      description2: 'We work closely with trusted partners in Mauritania to ensure consistent product quality and reliable supply for our clients.',
      description3: 'All products are carefully selected to meet international quality and sanitary standards.',
      established: 'Based In',
      establishedValue: 'Canada',
      markets: 'Activity',
      marketsValue: 'Seafood Import & Distribution',
      topZones: 'B2B',
      fishingZones: 'Supply Focus',
      richestWaters: 'Professional buyers only',
      focusPoints: [
        'Premium quality',
        'Full traceability',
        'Controlled cold chain',
        'Food safety compliance',
        'Reliable logistics',
        'Sustainable partnerships',
      ]
    },
    strengths: {
      title: 'OUR STRENGTHS',
      card1Title: 'PREMIUM WILD-CAUGHT SEAFOOD',
      card1Bullets: [
        'Sourced from the rich and pristine waters of the Mauritanian Atlantic Ocean.',
        'Wild-caught products selected for their quality, freshness, and market value.',
      ],
      card2Title: 'CONTROLLED COLD CHAIN',
      card2Bullets: [
        'Strict compliance with freezing, storage, and transportation standards.',
        'Product quality maintained throughout the entire supply chain.',
      ],
      card3Title: 'INTERNATIONAL EXPORT',
      card3Bullets: [
        'Solutions tailored to the requirements of international markets.',
        'Complete export documentation and logistics support.',
      ],
      card4Title: 'CERTIFIED PROCESSING FACILITIES',
      card4Bullets: [
        'Products processed in certified facilities in compliance with international food safety standards.',
        'Rigorous quality controls and full traceability ensured.',
      ],
    },
    quality: {
      title: 'QUALITY & COMPLIANCE',
      points: [
        'Products sourced from certified processing facilities',
        'Compliance with international food safety standards',
        'Rigorous quality control procedures',
        'Full product traceability',
        'Controlled cold chain management',
      ],
      certsTitle: 'Certifications',
      certs: [
        'Health certificates issued by ONISPA (Mauritania)',
        'ONISPA accredited: ISO 17020',
        'ONISPA accredited: ISO/IEC 17025',
        'AUTOFIT CANADA LTD holds a license issued by CFIA under the Safe Food for Canadians Act',
      ],
      marketsTitle: 'Market Access',
      markets: [
        '🇨🇦 Canada — CFIA / ACIA',
        '🇪🇺 European Union — DG SANTE / TRACES NT',
        '🇨🇳 China — GACC / CIFER',
        '🇯🇵 Japan — MHLW / QUARANTINE',
        '🇰🇷 South Korea — MFDS / NFQS',
      ],
    },
    logistics: {
      title: 'LOGISTICS & EXPORT',
      card1: 'Reefer Containers',
      card2: 'International Sea Freight',
      card3: 'FOB / CIF / DAP Solutions',
      card4: 'Reliable Supply Capacity',
    },
    certifications: {
      title: 'Certifications & Regulatory Compliance',
      subtitle: 'Recognized controls, accredited standards, and export-ready facilities for regulated seafood markets.',
      marketTitle: 'International Market Access',
      badges: [
        { label: 'ONISPA', caption: 'Health certificates issued by ONISPA (Mauritania)' },
        { label: 'ISO 17020', caption: 'ONISPA accredited according to ISO 17020 international standards' },
        { label: 'ISO/IEC 17025', caption: 'ONISPA accredited according to ISO/IEC 17025 international standards' },
        { label: 'ACIA · CFIA', caption: 'AUTOFIT CANADA LTD. holds a license issued by the Canadian Food Inspection Agency (CFIA) under the Safe Food for Canadians Act' },
        { label: 'CERTIFIED PROCESSING FACILITIES', caption: 'Products sourced from certified processing facilities operating under strict quality, hygiene, and traceability standards in accordance with destination market requirements' },
      ],
    },
    services: {
      badge: 'Our Services',
      title: 'Import Solutions',
      subtitle: 'Structured import solutions designed to support professional seafood buyers with reliable sourcing and international logistics.',
      b2bSupply: {
        title: 'B2B Supply',
        description: 'Bulk import operations structured to meet the demands of professional seafood buyers.',
        features: [
          'Bulk import operations',
          'Structured sourcing',
          'International compliance',
          'B2B focused supply'
        ]
      },
      wildCaught: {
        title: 'Wild-Caught Products',
        description: 'Exclusively wild-caught seafood sourced from the Atlantic Ocean off the coast of Mauritania.',
        features: [
          '100% wild-caught products',
          'Atlantic Ocean sourcing',
          'Natural, premium quality',
          'Carefully selected species'
        ]
      },
      internationalMarkets: {
        title: 'International Markets',
        description: 'Complete logistics management ensuring product integrity from source to destination across international markets.',
        features: [
          'Sea & air freight',
          'Controlled cold chain',
          'Reliable delivery',
          'Transparent logistics tracking'
        ]
      },
      ctaTitle: 'Ready to Start Your Order?',
      ctaSubtitle: 'Contact our team today to discuss your requirements and receive a tailored solution for your seafood needs.',
      requestQuote: 'Contact Us',
      whatsappUs: 'Contact via WhatsApp',
      learnMore: 'Learn more'
    },
    contact: {
      title: 'CONTACT US',
      tagline: 'Your Gateway to Premium Mauritanian Seafood',
      offices: [
        {
          flag: '🇨🇦',
          country: 'CANADA',
          address: '2730 Rue Châteauguay, App. 30\nMontréal (QC) H3K 1L4, Canada',
          phone: '+1 450 601 1665',
          email: 'info@autofitcanada.com',
          website: 'www.autofitcanada.com',
        },
        {
          flag: '🇫🇷',
          country: 'FRANCE',
          address: '273 Rue d\'Ocre, 59500 Douai',
          phone: '+33 6 58 64 58 57',
          email: 'info@autofitcanada.com',
          website: 'www.autofitcanada.com',
        },
        {
          flag: '🇲🇷',
          country: 'MAURITANIA',
          address: 'MGZ3 N° 0345 TVZ, Nouakchott',
          phone: '+222 49 12 01 33',
          email: 'info@autofitcanada.com',
          website: 'www.autofitcanada.com',
        },
      ],
      socialTitle: 'Follow Us',
      facebook: 'AUTOFIT CANADA LTD',
      linkedin: 'AUTOFIT CANADA LTD',
    },
    footer: {
      values: 'Why Choose Us',
      catalog: 'Catalog',
      about: 'About',
      services: 'Services',
      quality: 'Quality',
      logistics: 'Logistics',
      certifications: 'Certifications',
      privacy: 'Privacy',
      terms: 'Terms',
      copyright: 'AUTOFIT CANADA LTD. All rights reserved.'
    }
  },
  fr: {
    nav: {
      values: 'Pourquoi Nous Choisir',
      catalog: 'Catalogue',
      about: 'À Propos',
      quality: 'Qualité',
      logistics: 'Logistique',
      certifications: 'Certifications',
      contact_nav: 'Nous Contacter',
      whatsapp: 'WhatsApp',
      contact: 'Nous Contacter'
    },
    hero: {
      badge: 'Importateur de Fruits de Mer de Confiance',
      title: 'Votre partenaire de confiance pour les produits de la mer premium de Mauritanie',
      titleHighlight: '',
      titleEnd: '',
      subtitle: 'PRODUITS DE LA MER SAUVAGES DE MAURITANIE',
      btnPrimary: 'Explorer notre gamme',
      btnSecondary: 'Demander le catalogue',
      stat1: 'Importations en Conteneurs',
      stat2: 'Marchés Cibles',
      stat3: 'Surveillance Chaîne du Froid',
      freshCatch: 'Pêche Sauvage',
      delivery: 'Provenance Océan Atlantique',
      location: 'Importateur Basé au Canada',
      locationDesc: 'Fournissant des acheteurs professionnels au Canada et sur les marchés internationaux',
      scroll: 'Défiler'
    },
    values: {
      badge: 'Pourquoi Nous Choisir ?',
      title: 'POURQUOI NOUS CHOISIR ?',
      subtitle: 'Nos opérations sont conçues pour répondre aux besoins des acheteurs professionnels de fruits de mer grâce à un approvisionnement fiable, des processus d\'importation structurés et un approvisionnement constant.',
      reliability: {
        title: 'Produits sauvages premium',
        description: 'Approvisionnement exclusif en fruits de mer sauvages des eaux préservées de l\'Atlantique mauritanien.',
        features: [
          'Produits sauvages premium',
          'Service professionnel',
          'Partenaires fiables',
          'Réactivité commerciale'
        ]
      },
      accessibility: {
        title: 'Service professionnel',
        description: 'Solutions d\'approvisionnement dédiées aux acheteurs professionnels, distributeurs et entreprises de restauration.',
        features: [
          'Importateurs, distributeurs, grossistes',
          'Entreprises de restauration',
          'Partenariats à long terme',
          'Accords d\'approvisionnement structurés'
        ]
      },
      sustainability: {
        title: 'Qualité constante',
        description: 'Logistique contrôlée et opérations d\'importation structurées assurant une disponibilité constante des produits sur les marchés internationaux.',
        features: [
          'Partenaires fiables',
          'Réactivité commerciale',
          'Qualité constante',
          'Chaîne du froid maîtrisée'
        ]
      }
    },
    catalog: {
      badge: 'NOS PRODUITS',
      title: 'NOS PRODUITS',
      subtitle: 'Zone de pêche : FAO 34 – Atlantique Centre-Est | Présentation : Entier non vidé | Conditionnement : Carton de 10 kg ou 20 kg selon demande | Conservation : -18°C',
      // ungutted: 'Tous nos produits sont proposés entiers et non vidés.',
      viewDetails: 'Voir Détails',
      categories: {
        title: 'NOS CATÉGORIES',
        cat1Title: 'Crustacés',
        cat1Sub: 'Langouste / Crevette',
        cat2Title: 'Poissons Démersaux',
        cat2Sub: 'Dorade / Mérou / Sole / Rouget / Denté',
        cat3Title: 'Poissons Pélagiques',
        cat3Sub: 'Maquereau / Sardine / Chinchard',
        cat4Title: 'Céphalopodes',
        cat4Sub: 'Poulpe / Calamar / Seiche',
      },
      fish: {
        octopus: 'Poulpe',
        squid: 'Calmar',
        seaBream: 'Daurade',
        shrimp: 'Crevettes',
        sardines: 'Sardines',
        sole: 'Sole',
        cuttlefish: 'Seiche',
        lobster: 'Langouste',
        cynoglossus: 'Sole-langue sénégalaise',
        soleaSenegalensis: 'Sole de Roche',
        soleaSolea: 'Sole Perdrix juive',
        synaptura: 'Sole Tigrée',
        psettodes: 'Turbot',
        epinephelusAeneus: 'Mérou blanc',
        epinephelusGuaza: 'Mérou brun',
        pseudotolithus: 'Courbine du Sénégal',
        sparusAurata: 'Dorade royale',
        pagrusAuriga: 'Dorade',
        pagrusCaruleus: 'Dorade',
        pseudupeneus: 'Rouget',
        zeusFaber: 'Saint-Pierre',
        argyrosomus: 'Maigre',
        pomatomus: 'Tassergal',
        branchiostegus: 'À confirmer',
        dicentrarchus: 'Bar tacheté',
        plectorhinchus: 'Grondeur',
        anisotremus: 'Grondeur',
        trachurus: 'Chinchard',
        trachurusTrachurus: 'Chinchard',
        dentexMacrophthalmus: 'Denté',
        dentexAngolensis: 'Denté',
        campogramma: 'À confirmer',
        brotula: 'Brotule',
        galeichthys: 'Poisson-chat',
        scomber: 'Maquereau',
        stromateus: 'Fiatole',
        mugilCephalus: 'Mulet',
        mugilCurema: 'Mulet blanc',
        pagellus: 'Pageot',
        brachydeuterus: 'Grondeur',
        chloroscombrus: 'Plat-plat',
        drepane: 'Forgeron',
        raja: 'Raie',
        rhinobatos: 'Poisson guitare',
        pomadasys: 'Grondeur',
        galeoides: 'Capitaine',
        sardinellaAurita: 'Sardinelle ronde',
        sardinellaMaderensis: 'Sardinelle plate',
        sardinaPilchardus: 'Sardine commune',
        diplodus: 'Sar commun',
        pomadasysJubelini: 'Grondeur sompat',
        sardaSarda: 'Bonite à dos rayé',
        katsuwonus: 'Bonite à ventre rayé',
        thunnusThynnus: 'Thon rouge',
        oreochromisNiloticus: 'Tilapia du Nil',
      },
      cat: {
        premiumCatch: 'Prise Premium',
        whiteFish: 'Poisson Blanc',
        crustaceans: 'Crustacés',
        smallPelagics: 'Petits Pélagiques',
        flatfish: 'Poisson Plat',
        cephalopods: 'Céphalopodes',
        cephalopodesCrustaces: 'Céphalopodes / Crustacés',
        soles: 'Soles',
        merous: 'Mérous',
        courbinesDorades: 'Courbines / Dorades / Pagres',
        demersauxDivers: 'Démersaux divers',
        'pelagiquesChínchards': 'Pélagiques / Chinchards',
        dentesSparides: 'Dentés / Sparidés',
        casAVerifier: 'Cas à vérifier',
        autresEspeces: 'Autres espèces',
        raiesSelaciens: 'Raies / Sélaciens',
        demersauxSuite: 'Démersaux suite',
        petitsPelagiques: 'Petits pélagiques',
        thonsBonites: 'Thons / Bonites',
        eauDouce: 'Eau douce',
      },
      desc: {
        octopus: 'Poulpe atlantique sauvage — FAO 34, Atlantique Centre-Est',
        squid: 'Calmar européen sauvage — FAO 34, Atlantique Centre-Est',
        seaBream: 'Daurade premium des eaux côtières préservées',
        shrimp: 'Crevette rose des eaux profondes — FAO 34, Atlantique Centre-Est',
        sardines: 'Sardines riches en nutriments de la côte atlantique',
        sole: 'Sole délicate, parfaite pour la gastronomie',
        cuttlefish: 'Seiche commune sauvage — FAO 34, Atlantique Centre-Est',
        lobster: 'Langouste rose sauvage — FAO 34, Atlantique Centre-Est',
        cynoglossus: 'Sole-langue sénégalaise sauvage — FAO 34, Atlantique Centre-Est',
        soleaSenegalensis: 'Sole de Roche sauvage — FAO 34, Atlantique Centre-Est',
        soleaSolea: 'Sole Perdrix juive sauvage — FAO 34, Atlantique Centre-Est',
        synaptura: 'Sole Tigrée sauvage — FAO 34, Atlantique Centre-Est',
        psettodes: 'Turbot sauvage — FAO 34, Atlantique Centre-Est',
        epinephelusAeneus: 'Mérou blanc sauvage — FAO 34, Atlantique Centre-Est',
        epinephelusGuaza: 'Mérou brun sauvage — FAO 34, Atlantique Centre-Est',
        pseudotolithus: 'Courbine du Sénégal sauvage — FAO 34, Atlantique Centre-Est',
        sparusAurata: 'Dorade royale sauvage — FAO 34, Atlantique Centre-Est',
        pagrusAuriga: 'Dorade sauvage — FAO 34, Atlantique Centre-Est',
        pagrusCaruleus: 'Dorade sauvage — FAO 34, Atlantique Centre-Est',
        pseudupeneus: 'Rouget sauvage — FAO 34, Atlantique Centre-Est',
        zeusFaber: 'Saint-Pierre sauvage — FAO 34, Atlantique Centre-Est',
        argyrosomus: 'Maigre sauvage — FAO 34, Atlantique Centre-Est',
        pomatomus: 'Tassergal sauvage — FAO 34, Atlantique Centre-Est',
        branchiostegus: 'Branchiostegus sauvage — FAO 34, Atlantique Centre-Est',
        dicentrarchus: 'Bar tacheté sauvage — FAO 34, Atlantique Centre-Est',
        plectorhinchus: 'Grondeur sauvage — FAO 34, Atlantique Centre-Est',
        anisotremus: 'Grondeur sauvage — FAO 34, Atlantique Centre-Est',
        trachurus: 'Chinchard méditerranéen sauvage — FAO 34, Atlantique Centre-Est',
        trachurusTrachurus: 'Chinchard atlantique sauvage — FAO 34, Atlantique Centre-Est',
        dentexMacrophthalmus: 'Denté sauvage — FAO 34, Atlantique Centre-Est',
        dentexAngolensis: 'Denté sauvage — FAO 34, Atlantique Centre-Est',
        campogramma: 'Vadigo sauvage — FAO 34, Atlantique Centre-Est',
        brotula: 'Brotule sauvage — FAO 34, Atlantique Centre-Est',
        galeichthys: 'Poisson-chat sauvage — FAO 34, Atlantique Centre-Est',
        scomber: 'Maquereau atlantique sauvage — FAO 34, Atlantique Centre-Est',
        stromateus: 'Fiatole sauvage — FAO 34, Atlantique Centre-Est',
        mugilCephalus: 'Mulet sauvage — FAO 34, Atlantique Centre-Est',
        mugilCurema: 'Mulet blanc sauvage — FAO 34, Atlantique Centre-Est',
        pagellus: 'Pageot sauvage — FAO 34, Atlantique Centre-Est',
        brachydeuterus: 'Grondeur sauvage — FAO 34, Atlantique Centre-Est',
        chloroscombrus: 'Plat-plat sauvage — FAO 34, Atlantique Centre-Est',
        drepane: 'Forgeron sauvage — FAO 34, Atlantique Centre-Est',
        raja: 'Raie sauvage — FAO 34, Atlantique Centre-Est',
        rhinobatos: 'Poisson guitare sauvage — FAO 34, Atlantique Centre-Est',
        pomadasys: 'Grondeur sauvage — FAO 34, Atlantique Centre-Est',
        galeoides: 'Capitaine sauvage — FAO 34, Atlantique Centre-Est',
        sardinellaAurita: 'Sardinelle ronde sauvage — FAO 34, Atlantique Centre-Est',
        sardinellaMaderensis: 'Sardinelle plate sauvage — FAO 34, Atlantique Centre-Est',
        sardinaPilchardus: 'Sardine commune sauvage — FAO 34, Atlantique Centre-Est',
        diplodus: 'Sar commun sauvage — FAO 34, Atlantique Centre-Est',
        pomadasysJubelini: 'Grondeur sompat sauvage — FAO 34, Atlantique Centre-Est',
        sardaSarda: 'Bonite à dos rayé sauvage — FAO 34, Atlantique Centre-Est',
        katsuwonus: 'Bonite à ventre rayé sauvage — FAO 34, Atlantique Centre-Est',
        thunnusThynnus: 'Thon rouge sauvage — FAO 34, Atlantique Centre-Est',
        oreochromisNiloticus: 'Tilapia du Nil sauvage — FAO 34, Atlantique Centre-Est',
      }
    },
    about: {
      badge: 'À Propos d\'AUTOFIT CANADA',
      title: 'À PROPOS DE NOUS',
      titleHighlight: '',
      description1: 'AUTOFIT CANADA LTD est une société canadienne spécialisée dans l\'importation et la distribution de produits de la mer sauvages de haute qualité en provenance de Mauritanie. Grâce à notre réseau de partenaires et d\'usines agréées, nous fournissons des produits répondant aux exigences des marchés internationaux, notamment le Canada, l\'Union européenne, l\'Afrique et l\'Asie.',
      missionTitle: 'NOUS METTONS L\'ACCENT SUR',
      mission: 'La qualité premium · La traçabilité · La chaîne du froid maîtrisée · La conformité sanitaire · La fiabilité logistique · Les partenariats durables',
      description2: 'Nous travaillons en étroite collaboration avec des partenaires de confiance en Mauritanie pour garantir une qualité de produit constante et un approvisionnement fiable pour nos clients.',
      description3: 'Tous les produits sont soigneusement sélectionnés pour répondre aux normes internationales de qualité et sanitaires.',
      established: 'Basé En',
      establishedValue: 'Canada',
      markets: 'Activité',
      marketsValue: 'Importation & Distribution de Fruits de Mer',
      topZones: 'B2B',
      fishingZones: 'Focus Approvisionnement',
      richestWaters: 'Acheteurs professionnels uniquement',
      focusPoints: [
        'La qualité premium',
        'La traçabilité',
        'La chaîne du froid maîtrisée',
        'La conformité sanitaire',
        'La fiabilité logistique',
        'Les partenariats durables',
      ]
    },
    strengths: {
      title: 'NOS AVANTAGES',
      card1Title: 'PRODUITS DE LA MER SAUVAGES HAUT DE GAMME',
      card1Bullets: [
        'Issus des eaux riches et préservées de l\'Atlantique mauritanien.',
        'Produits sauvages sélectionnés pour leur qualité, leur fraîcheur et leur valeur commerciale.',
      ],
      card2Title: 'CHAÎNE DU FROID MAÎTRISÉE',
      card2Bullets: [
        'Respect strict des normes de congélation, de stockage et de transport.',
        'Maintien de la qualité du produit tout au long de la chaîne logistique.',
      ],
      card3Title: 'EXPORTATION INTERNATIONALE',
      card3Bullets: [
        'Solutions adaptées aux exigences des marchés internationaux.',
        'Documentation export et accompagnement logistique complets.',
      ],
      card4Title: 'USINES PARTENAIRES AGRÉÉES',
      card4Bullets: [
        'Produits transformés dans des établissements agréés conformément aux normes sanitaires internationales.',
        'Contrôles qualité rigoureux et traçabilité assurée.',
      ],
    },
    quality: {
      title: 'QUALITÉ & CONFORMITÉ',
      points: [
        'Produits issus d\'usines partenaires agréées',
        'Respect des normes sanitaires internationales',
        'Contrôle qualité rigoureux',
        'Traçabilité des produits',
        'Chaîne du froid maîtrisée',
      ],
      certsTitle: 'Certifications',
      certs: [
        'Certificats sanitaires délivrés par l\'ONISPA (Mauritanie)',
        'ONISPA accrédité : ISO 17020',
        'ONISPA accrédité : ISO/IEC 17025',
        'AUTOFIT CANADA LTD détient une licence délivrée par l\'ACIA en vertu de la Loi sur la salubrité des aliments au Canada',
      ],
      marketsTitle: 'Accès aux Marchés',
      markets: [
        '🇨🇦 Canada — CFIA / ACIA',
        '🇪🇺 Union Européenne — DG SANTE / TRACES NT',
        '🇨🇳 Chine — GACC / CIFER',
        '🇯🇵 Japon — MHLW / QUARANTINE',
        '🇰🇷 Corée du Sud — MFDS / NFQS',
      ],
    },
    logistics: {
      title: 'LOGISTIQUE & EXPORTATION',
      card1: 'Conteneurs frigorifiques',
      card2: 'Export maritime international',
      card3: 'Solutions FOB / CIF / DAP',
      card4: 'Capacité d\'approvisionnement régulière',
    },
    certifications: {
      title: 'Certifications et Conformité Réglementaire',
      subtitle: "Contrôles reconnus, normes accréditées et installations prêtes à l'export pour les marchés réglementés.",
      marketTitle: 'Accès aux Marchés Internationaux',
      badges: [
        { label: 'ONISPA', caption: "Certificats sanitaires délivrés par l'ONISPA (Mauritania)" },
        { label: 'ISO 17020', caption: 'ONISPA accrédité selon les normes internationales ISO 17020' },
        { label: 'ISO/IEC 17025', caption: 'ONISPA accrédité selon les normes internationales ISO/IEC 17025' },
        { label: 'ACIA · CFIA', caption: "AUTOFIT CANADA LTD détient une licence délivrée par l'Agence canadienne d'inspection des aliments (ACIA), conformément à la Loi sur la salubrité des aliments au Canada" },
        { label: 'USINES PARTENAIRES AGRÉÉES', caption: "Produits issus d'usines partenaires agréées appliquant des normes rigoureuses de qualité, d'hygiène et de traçabilité conformément aux exigences du marché de destination" },
      ],
    },  
    services: {
      badge: 'Nos Services',
      title: 'Solutions d\'Importation',
      subtitle: 'Solutions d\'importation structurées conçues pour soutenir les acheteurs professionnels de fruits de mer avec un approvisionnement fiable et une logistique internationale.',
      b2bSupply: {
        title: 'Approvisionnement B2B',
        description: 'Opérations d\'importation en vrac structurées pour répondre aux demandes des acheteurs professionnels.',
        features: [
          'Opérations d\'importation en vrac',
          'Approvisionnement structuré',
          'Conformité internationale',
          'Approvisionnement axé B2B'
        ]
      },
      wildCaught: {
        title: 'Produits Sauvages',
        description: 'Fruits de mer exclusivement sauvages provenant de l\'Océan Atlantique au large des côtes de Mauritanie.',
        features: [
          'Produits 100% sauvages',
          'Approvisionnement Océan Atlantique',
          'Qualité naturelle et premium',
          'Espèces soigneusement sélectionnées'
        ]
      },
      internationalMarkets: {
        title: 'Marchés Internationaux',
        description: 'Gestion logistique complète garantissant l\'intégrité du produit de la source à la destination sur les marchés internationaux.',
        features: [
          'Fret maritime et aérien',
          'Chaîne du froid contrôlée',
          'Livraison fiable',
          'Suivi logistique transparent'
        ]
      },
      ctaTitle: 'Prêt à Passer Votre Commande?',
      ctaSubtitle: 'Contactez notre équipe aujourd\'hui pour discuter de vos besoins et recevoir une solution adaptée à vos besoins en fruits de mer.',
      requestQuote: 'Nous Contacter',
      whatsappUs: 'Contacter via WhatsApp',
      learnMore: 'En savoir plus'
    },
    contact: {
      title: 'CONTACTEZ-NOUS',
      tagline: 'Votre passerelle vers les produits de la mer premium de Mauritanie',
      offices: [
        {
          flag: '🇨🇦',
          country: 'CANADA',
          address: '2730 Rue Châteauguay, App. 30\nMontréal (QC) H3K 1L4, Canada',
          phone: '+1 450 601 1665',
          email: 'info@autofitcanada.com',
          website: 'www.autofitcanada.com',
        },
        {
          flag: '🇫🇷',
          country: 'FRANCE',
          address: '273 Rue d\'Ocre, 59500 Douai',
          phone: '+33 6 58 64 58 57',
          email: 'info@autofitcanada.com',
          website: 'www.autofitcanada.com',
        },
        {
          flag: '🇲🇷',
          country: 'MAURITANIE',
          address: 'MGZ3 N° 0345 TVZ, Nouakchott',
          phone: '+222 49 12 01 33',
          email: 'info@autofitcanada.com',
          website: 'www.autofitcanada.com',
        },
      ],
      socialTitle: 'Suivez-Nous',
      facebook: 'AUTOFIT CANADA LTD',
      linkedin: 'AUTOFIT CANADA LTD',
    },
    footer: {
      values: 'Pourquoi Nous Choisir',
      catalog: 'Catalogue',
      about: 'À Propos',
      services: 'Services',
      quality: 'Qualité',
      logistics: 'Logistique',
      certifications: 'Certifications',
      privacy: 'Confidentialité',
      terms: 'Conditions',
      copyright: 'AUTOFIT CANADA LTD. Tous droits réservés.'
    }
  },
  ar: {
    nav: {
      values: 'لماذا تختارنا',
      catalog: 'الكتالوج',
      about: 'من نحن',
      quality: 'الجودة',
      logistics: 'الخدمات اللوجستية',
      certifications: 'الشهادات',
      contact_nav: 'اتصل بنا',
      whatsapp: 'واتساب',
      contact: 'اتصل بنا'
    },
    hero: {
      badge: 'مستورد موثوق للمأكولات البحرية',
      title: 'شريكك الموثوق للمأكولات البحرية الطازجة من موريتانيا',
      titleHighlight: '',
      titleEnd: '',
      subtitle: 'منتجات بحرية طازجة من موريتانيا',
      btnPrimary: 'استكشف منتجاتنا',
      btnSecondary: 'طلب الكتالوج',
      stat1: 'استيراد بالحاويات',
      stat2: 'أسواق مستهدفة',
      stat3: 'مراقبة سلسلة التبريد',
      freshCatch: 'صيد بري',
      delivery: 'مصدر من المحيط الأطلسي',
      location: 'مستورد مقره كندا',
      locationDesc: 'تزويد المشترين المحترفين في كندا والأسواق الدولية',
      scroll: 'تمرير'
    },
    values: {
      badge: 'لماذا تختار AUTOFIT CANADA',
      title: 'لماذا تختار AUTOFIT CANADA',
      subtitle: 'عملياتنا مصممة لتلبية احتياجات المشترين المحترفين للمأكولات البحرية من خلال التوريد الموثوق وعمليات الاستيراد المنظمة والإمداد المتسق.',
      reliability: {
        title: 'إمداد B2B',
        description: 'حلول إمداد مخصصة للمشترين المحترفين والموزعين وشركات خدمات الطعام.',
        features: [
          'المستوردون والموزعين وتجار الجملة',
          'شركات خدمات الطعام',
          'شراكات طويلة الأمد',
          'اتفاقيات إمداد منظمة'
        ]
      },
      accessibility: {
        title: 'منتجات برية',
        description: 'توريد حصري للمأكولات البحرية البرية من المحيط الأطلسي لجودة طبيعية ومتميزة.',
        features: [
          'منتجات 100% برية',
          'توريد من المحيط الأطلسي',
          'منتجات طبيعية',
          'أنواع مختارة بعناية'
        ]
      },
      sustainability: {
        title: 'الأسواق الدولية',
        description: 'لوجستيات مراقبة وعمليات استيراد منظمة تضمن توافر المنتج باستمرار في الأسواق الدولية.',
        features: [
          'سلسلة تبريد مراقبة',
          'عمليات استيراد منظمة',
          'توافر مستمر',
          'جداول تسليم موثوقة'
        ]
      }
    },
    catalog: {
      badge: 'منتجاتنا',
      title: 'منتجاتنا',
      subtitle: 'منطقة الصيد: FAO 34 – وسط شرق الأطلسي | التقديم: كامل غير منزوع الأحشاء | التعبئة: كرتون 10 كغ أو 20 كغ حسب الطلب | التخزين: 18°C-',
      // ungutted: 'جميع منتجاتنا تُقدَّم كاملة وغير منزوعة الأحشاء.',
      viewDetails: 'عرض التفاصيل',
      categories: {
        title: 'فئاتنا',
        cat1Title: 'قشريات',
        cat1Sub: 'جراد البحر / روبيان',
        cat2Title: 'أسماك قاعية',
        cat2Sub: 'دنيس / هامور / موسى / سلطان إبراهيم / دنتكس',
        cat3Title: 'أسماك سطحية',
        cat3Sub: 'ماكريل / سردين / إسقمري حصان',
        cat4Title: 'رأسيات الأرجل',
        cat4Sub: 'أخطبوط / حبار / سيبيا',
      },
      fish: {
        octopus: 'أخطبوط',
        squid: 'حبار كالاماري',
        seaBream: 'دنيس',
        shrimp: 'روبيان',
        sardines: 'سردين',
        sole: 'سمك موسى',
        cuttlefish: 'حبار',
        lobster: 'جراد البحر',
        cynoglossus: 'سمك اللسان السنغالي',
        soleaSenegalensis: 'موسى سنغالي',
        soleaSolea: 'موسى شائع',
        synaptura: 'موسى كاديناتي',
        psettodes: 'هلبوت بيلشر',
        epinephelusAeneus: 'هامور أبيض',
        epinephelusGuaza: 'هامور داكن',
        pseudotolithus: 'أوتوليث سنغالي',
        sparusAurata: 'دنيس ذهبي',
        pagrusAuriga: 'باغروس إبطي',
        pagrusCaruleus: 'باغروس منقط أزرق',
        pseudupeneus: 'سلطان إبراهيم غرب أفريقيا',
        zeusFaber: 'سمك القديس بطرس',
        argyrosomus: 'ميغر',
        pomatomus: 'بلوفيش',
        branchiostegus: 'سمك البلاط نصف المخطط',
        dicentrarchus: 'قاروص منقط',
        plectorhinchus: 'شفاه حلوة متوسطية',
        anisotremus: 'مارغيت أسود',
        trachurus: 'إسقمري حصان متوسطي',
        trachurusTrachurus: 'إسقمري حصان أطلسي',
        dentexMacrophthalmus: 'دنتكس كبير العيون',
        dentexAngolensis: 'دنتكس أنغولي',
        campogramma: 'فاديغو',
        brotula: 'بروتولا ذات اللحية',
        galeichthys: 'قطس البحر',
        scomber: 'إسقمري أطلسي',
        stromateus: 'ستروماتيوس فضي',
        mugilCephalus: 'بوري رأس مفلطح',
        mugilCurema: 'بوري أبيض',
        pagellus: 'باجيلوس وردي',
        brachydeuterus: 'نهاش كبير العين',
        chloroscombrus: 'كارانكس أطلسي',
        drepane: 'سمكة المنجل الأفريقية',
        raja: 'راجا بنية',
        rhinobatos: 'أبو مطرقة الشائع',
        pomadasys: 'نهاش هجين',
        galeoides: 'خيط أفريقي صغير',
        sardinellaAurita: 'سردينيلا مستديرة',
        sardinellaMaderensis: 'سردينيلا ماديرا',
        sardinaPilchardus: 'سردين أوروبي',
        diplodus: 'دبلودوس أبيض',
        pomadasysJubelini: 'نهاش سومبات',
        sardaSarda: 'بونيتو أطلسي',
        katsuwonus: 'تونة سكيبجاك',
        thunnusThynnus: 'تونة زرقاء أطلسية',
        oreochromisNiloticus: 'بلطي نيلي',
      },
      cat: {
        premiumCatch: 'صيد متميز',
        whiteFish: 'سمك أبيض',
        crustaceans: 'قشريات',
        smallPelagics: 'أسماك صغيرة',
        flatfish: 'سمك مفلطح',
        cephalopods: 'رأسيات الأرجل',
        cephalopodesCrustaces: 'Cephalopods / Crustaceans',
        soles: 'Soles',
        merous: 'Groupers',
        courbinesDorades: 'Croakers / Seabreams',
        demersauxDivers: 'Demersal Species',
        'pelagiquesChínchards': 'Pelagics / Horse Mackerel',
        dentesSparides: 'Dentex / Sparidae',
        casAVerifier: 'To Be Confirmed',
        autresEspeces: 'Other Species',
        raiesSelaciens: 'Rays / Elasmobranchs',
        demersauxSuite: 'Demersal Species (cont.)',
        petitsPelagiques: 'Small Pelagics',
        thonsBonites: 'Tunas / Bonitos',
        eauDouce: 'Freshwater',
      },
      desc: {
        octopus: 'أخطبوط أطلسي طازج، مختار ومعالج بعناية',
        squid: 'حبار أطلسي بري بقوام متماسك ونكهة رقيقة',
        seaBream: 'دنيس متميز من المياه الساحلية النقية',
        shrimp: 'روبيان وردي بري من المياه العميقة',
        sardines: 'سردين غني بالمغذيات من الساحل الأطلسي',
        sole: 'سمك موسى الرقيق، مثالي للمطاعم الراقية',
        cuttlefish: 'حبار طازج بجودة وطزاجة فائقة',
        lobster: 'جراد بحر متميز من المياه الأطلسية قبالة سواحل موريتانيا',
        cynoglossus: 'سمك اللسان السنغالي البري من المياه الأطلسية',
        soleaSenegalensis: 'موسى سنغالي بري من المياه الأطلسية',
        soleaSolea: 'موسى شائع بري من المياه الأطلسية',
        synaptura: 'موسى كاديناتي بري من المياه الأطلسية',
        psettodes: 'هلبوت بيلشر بري من المياه الأطلسية',
        epinephelusAeneus: 'هامور أبيض بري من المياه الأطلسية',
        epinephelusGuaza: 'هامور داكن بري من المياه الأطلسية',
        pseudotolithus: 'أوتوليث سنغالي بري من المياه الأطلسية',
        sparusAurata: 'دنيس ذهبي بري من المياه الأطلسية',
        pagrusAuriga: 'باغروس إبطي بري من المياه الأطلسية',
        pagrusCaruleus: 'باغروس منقط أزرق بري من المياه الأطلسية',
        pseudupeneus: 'سلطان إبراهيم غرب أفريقيا بري من المياه الأطلسية',
        zeusFaber: 'سمك القديس بطرس بري من المياه الأطلسية',
        argyrosomus: 'ميغر بري من المياه الأطلسية',
        pomatomus: 'بلوفيش بري من المياه الأطلسية',
        branchiostegus: 'سمك البلاط نصف المخطط بري من المياه الأطلسية',
        dicentrarchus: 'قاروص منقط بري من المياه الأطلسية',
        plectorhinchus: 'شفاه حلوة متوسطية برية من المياه الأطلسية',
        anisotremus: 'مارغيت أسود بري من المياه الأطلسية',
        trachurus: 'إسقمري حصان متوسطي بري من المياه الأطلسية',
        trachurusTrachurus: 'إسقمري حصان أطلسي بري من المياه الأطلسية',
        dentexMacrophthalmus: 'دنتكس كبير العيون بري من المياه الأطلسية',
        dentexAngolensis: 'دنتكس أنغولي بري من المياه الأطلسية',
        campogramma: 'فاديغو بري من المياه الأطلسية',
        brotula: 'بروتولا ذات اللحية برية من المياه الأطلسية',
        galeichthys: 'قطس البحر بري من المياه الأطلسية',
        scomber: 'إسقمري أطلسي بري من المياه الأطلسية',
        stromateus: 'ستروماتيوس فضي بري من المياه الأطلسية',
        mugilCephalus: 'بوري رأس مفلطح بري من المياه الأطلسية',
        mugilCurema: 'بوري أبيض بري من المياه الأطلسية',
        pagellus: 'باجيلوس وردي بري من المياه الأطلسية',
        brachydeuterus: 'نهاش كبير العين بري من المياه الأطلسية',
        chloroscombrus: 'كارانكس أطلسي بري من المياه الأطلسية',
        drepane: 'سمكة المنجل الأفريقية برية من المياه الأطلسية',
        raja: 'راجا بنية برية من المياه الأطلسية',
        rhinobatos: 'أبو مطرقة الشائع بري من المياه الأطلسية',
        pomadasys: 'نهاش هجين بري من المياه الأطلسية',
        galeoides: 'خيط أفريقي صغير بري من المياه الأطلسية',
        sardinellaAurita: 'سردينيلا مستديرة برية من المياه الأطلسية',
        sardinellaMaderensis: 'سردينيلا ماديرا برية من المياه الأطلسية',
        sardinaPilchardus: 'سردين أوروبي بري من المياه الأطلسية',
        diplodus: 'دبلودوس أبيض بري من المياه الأطلسية',
        pomadasysJubelini: 'نهاش سومبات بري من المياه الأطلسية',
        sardaSarda: 'بونيتو أطلسي بري من المياه الأطلسية',
        katsuwonus: 'تونة سكيبجاك برية من المياه الأطلسية',
        thunnusThynnus: 'تونة زرقاء أطلسية برية من المياه الأطلسية',
        oreochromisNiloticus: 'بلطي نيلي بري من المياه الأطلسية',
      }
    },
    about: {
      badge: 'حول AUTOFIT CANADA',
      title: 'من نحن',
      titleHighlight: '',
      description1: 'AUTOFIT CANADA LTD هي شركة كندية متخصصة في استيراد وتوزيع منتجات المأكولات البحرية البرية الممتازة من موريتانيا.',
      missionTitle: 'نركز على',
      mission: 'الجودة الممتازة · التتبع الكامل · سلسلة التبريد المراقبة · الامتثال لسلامة الغذاء · اللوجستيات الموثوقة · الشراكات المستدامة',
      description2: 'نعمل بشكل وثيق مع شركاء موثوقين في موريتانيا لضمان جودة منتج متسقة وإمداد موثوق لعملائنا.',
      description3: 'جميع المنتجات مختارة بعناية لتلبية معايير الجودة والصحة الدولية.',
      established: 'مقرها في',
      establishedValue: 'كندا',
      markets: 'النشاط',
      marketsValue: 'استيراد وتوزيع المأكولات البحرية',
      topZones: 'B2B',
      fishingZones: 'تركيز الإمداد',
      richestWaters: 'للمشترين المحترفين فقط',
      focusPoints: [
        'الجودة الممتازة',
        'التتبع الكامل',
        'سلسلة التبريد المراقبة',
        'الامتثال لسلامة الغذاء',
        'اللوجستيات الموثوقة',
        'الشراكات المستدامة',
      ]
    },
    strengths: {
      title: 'مزايانا',
      card1Title: 'منتجات بحرية برية فاخرة',
      card1Bullets: [
        'مصدرها المياه الغنية والنقية للمحيط الأطلسي الموريتاني.',
        'منتجات برية مختارة لجودتها وطزاجتها وقيمتها التجارية.',
      ],
      card2Title: 'سلسلة تبريد مراقبة',
      card2Bullets: [
        'الامتثال الصارم لمعايير التجميد والتخزين والنقل.',
        'الحفاظ على جودة المنتج طوال سلسلة التوريد.',
      ],
      card3Title: 'تصدير دولي',
      card3Bullets: [
        'حلول مصممة وفق متطلبات الأسواق الدولية.',
        'وثائق التصدير والدعم اللوجستي الكامل.',
      ],
      card4Title: 'مرافق معالجة معتمدة',
      card4Bullets: [
        'منتجات معالجة في مرافق معتمدة وفق معايير سلامة الغذاء الدولية.',
        'ضمان ضوابط الجودة الصارمة والتتبع الكامل.',
      ],
    },
    quality: {
      title: 'الجودة والامتثال',
      points: [
        'منتجات من مرافق معالجة معتمدة',
        'الامتثال لمعايير سلامة الغذاء الدولية',
        'إجراءات صارمة لمراقبة الجودة',
        'تتبع كامل للمنتج',
        'إدارة سلسلة التبريد المراقبة',
      ],
      certsTitle: 'الشهادات',
      certs: [
        'شهادات صحية صادرة عن ONISPA (موريتانيا)',
        'ONISPA معتمد: ISO 17020',
        'ONISPA معتمد: ISO/IEC 17025',
        'AUTOFIT CANADA LTD تحمل ترخيصاً صادراً عن CFIA',
      ],
      marketsTitle: 'الوصول إلى الأسواق',
      markets: [
        '🇨🇦 كندا — CFIA / ACIA',
        '🇪🇺 الاتحاد الأوروبي — DG SANTE / TRACES NT',
        '🇨🇳 الصين — GACC / CIFER',
        '🇯🇵 اليابان — MHLW / QUARANTINE',
        '🇰🇷 كوريا الجنوبية — MFDS / NFQS',
      ],
    },
    logistics: {
      title: 'اللوجستيات والتصدير',
      card1: 'حاويات مبردة',
      card2: 'شحن بحري دولي',
      card3: 'حلول FOB / CIF / DAP',
      card4: 'قدرة توريد موثوقة',
    },
    certifications: {
      title: 'الشهادات والامتثال التنظيمي',
      subtitle: 'رقابة معترف بها ومعايير معتمدة ومنشآت جاهزة للتصدير إلى أسواق المنتجات البحرية المنظمة.',
      marketTitle: 'الوصول إلى الأسواق الدولية',
      badges: [
        { label: 'ONISPA', caption: 'شهادات صحية صادرة عن ONISPA (موريتانيا)' },
        { label: 'ISO 17020', caption: 'ONISPA معتمد وفق معايير ISO 17020 الدولية' },
        { label: 'ISO/IEC 17025', caption: 'ONISPA معتمد وفق معايير ISO/IEC 17025 الدولية' },
        { label: 'ACIA · CFIA', caption: 'تحمل AUTOFIT CANADA LTD ترخيصاً صادراً عن وكالة التفتيش الغذائي الكندية (CFIA) بموجب قانون سلامة الغذاء للكنديين' },
        { label: 'منشآت معالجة معتمدة', caption: 'منتجات من منشآت معالجة معتمدة تعمل وفق معايير صارمة للجودة والنظافة والتتبع وفقاً لمتطلبات السوق المستهدف' },
      ],
    },
    services: {
      badge: 'خدماتنا',
      title: 'حلول الاستيراد',
      subtitle: 'حلول استيراد منظمة مصممة لدعم المشترين المحترفين للمأكولات البحرية بتوريد موثوق ولوجستيات دولية.',
      b2bSupply: {
        title: 'إمداد B2B',
        description: 'عمليات استيراد بالجملة منظمة لتلبية متطلبات المشترين المحترفين.',
        features: [
          'عمليات استيراد بالجملة',
          'توريد منظم',
          'امتثال دولي',
          'إمداد موجه للـ B2B'
        ]
      },
      wildCaught: {
        title: 'منتجات برية',
        description: 'مأكولات بحرية برية حصرياً من المحيط الأطلسي قبالة سواحل موريتانيا.',
        features: [
          'منتجات 100% برية',
          'توريد من المحيط الأطلسي',
          'جودة طبيعية ومتميزة',
          'أنواع مختارة بعناية'
        ]
      },
      internationalMarkets: {
        title: 'الأسواق الدولية',
        description: 'إدارة لوجستية كاملة تضمن سلامة المنتج من المصدر إلى الوجهة في الأسواق الدولية.',
        features: [
          'شحن بحري وجوي',
          'سلسلة تبريد مراقبة',
          'تسليم موثوق',
          'تتبع لوجستي شفاف'
        ]
      },
      ctaTitle: 'هل أنت مستعد لبدء طلبك؟',
      ctaSubtitle: 'اتصل بفريقنا اليوم لمناقشة متطلباتك والحصول على حل مخصص لاحتياجاتك من المأكولات البحرية.',
      requestQuote: 'اتصل بنا',
      whatsappUs: 'التواصل عبر واتساب',
      learnMore: 'اعرف المزيد'
    },
    contact: {
      title: 'اتصل بنا',
      tagline: 'بوابتك إلى المأكولات البحرية الموريتانية الممتازة',
      offices: [
        {
          flag: '🇨🇦',
          country: 'كندا',
          address: "2730 شارع شاتوغيه، شقة 30\nمونتريال (كيبيك) H3K 1L4، كندا",
          phone: '+1 450 601 1665',
          email: 'info@autofitcanada.com',
          website: 'www.autofitcanada.com',
        },
        {
          flag: '🇫🇷',
          country: 'فرنسا',
          address: "273 شارع أوكر، 59500 دواي، فرنسا",
          phone: '+33 6 58 64 58 57',
          email: 'info@autofitcanada.com',
          website: 'www.autofitcanada.com',
        },
        {
          flag: '🇲🇷',
          country: 'موريتانيا',
          address: "MGZ3 رقم 0345 TVZ، نواكشوط، موريتانيا",
          phone: '+222 49 12 01 33',
          email: 'info@autofitcanada.com',
          website: 'www.autofitcanada.com',
        },
      ],
      socialTitle: 'تابعنا',
      facebook: 'AUTOFIT CANADA LTD',
      linkedin: 'AUTOFIT CANADA LTD',
    },
    footer: {
      values: 'لماذا تختارنا',
      catalog: 'الكتالوج',
      about: 'من نحن',
      services: 'الخدمات',
      quality: 'الجودة',
      logistics: 'الخدمات اللوجستية',
      certifications: 'الشهادات',
      privacy: 'الخصوصية',
      terms: 'الشروط',
      copyright: 'AUTOFIT CANADA LTD. جميع الحقوق محفوظة.'
    }
  }
};